import React from 'react'

import Text from '../../ui/Text'
import { getChargerProductDefinition, MeasurementDeviceProducts } from '../enums/Products'

export const getProductName = (productId?: string | number, formatted = true): string | React.ReactElement => {
    if (!productId) return ''
    const id = Number(productId)
    if (id === MeasurementDeviceProducts.AmpGuard) return 'Charge Amps Amp Guard'
    if (id === MeasurementDeviceProducts.AmpGuard2) return 'Charge Amps Amp Guard 2'
    if (id === MeasurementDeviceProducts.Enegic) return 'Perific'

    const chargerProduct = getChargerProductDefinition(id)
    if (chargerProduct) {
        return formatted ? <Text code={chargerProduct.translationKey} /> : chargerProduct.brandedName
    }

    return ''
}

export const getShortProductName = (productId: string | number) => {
    switch (productId) {
        case MeasurementDeviceProducts.AmpGuard:
            return 'AG1'
        case MeasurementDeviceProducts.AmpGuard2:
            return 'AG2'
        case MeasurementDeviceProducts.Enegic:
            return 'PRFC'
        default:
            return ''
    }
}
